// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  login: '/login',
  register: '/register',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  profile: {
    root: path(ROOTS_DASHBOARD, '/profile'),
  },
  users: {
    root: path(ROOTS_DASHBOARD, '/users'),
    addUser: path(ROOTS_DASHBOARD, '/users/add-user'),
    edit: (name) => path(ROOTS_DASHBOARD, `/users/edit/${name}`),
  },
  teams: {
    root: path(ROOTS_DASHBOARD, '/teams'),
    new: path(ROOTS_DASHBOARD, '/teams/new'),
    edit: (id) => path(ROOTS_DASHBOARD, `/teams/edit/${id}`),
  },
  customers: {
    root: path(ROOTS_DASHBOARD, '/customers'),
    addCustomer: path(ROOTS_DASHBOARD, '/customers/add-customer'),
    edit: (name) => path(ROOTS_DASHBOARD, `/customers/edit/${name}`),
    accountManager: path(ROOTS_DASHBOARD, '/customers/account-manager'),
  },
  partners: {
    root: path(ROOTS_DASHBOARD, '/partners'),
    setup: path(ROOTS_DASHBOARD, '/partners/account-setup'),
    profile: path(ROOTS_DASHBOARD, '/partners/profile'),
    addPartner: path(ROOTS_DASHBOARD, '/partners/add-partner'),
    edit: (name) => path(ROOTS_DASHBOARD, `/partners/edit/${name}`),
  },
  googleWorkspace: {
    root: path(ROOTS_DASHBOARD, '/google-workspace'),
    customers: path(ROOTS_DASHBOARD, '/google-workspace/customers'),
    workspaceCustomerInfo: path(ROOTS_DASHBOARD, '/google-workspace/customers/info'),
    transactions: path(ROOTS_DASHBOARD, '/google-workspace/transactions'),
  },
  whatsApp: {
    root: path(ROOTS_DASHBOARD, '/whatsapp'),
    // billing: path(ROOTS_DASHBOARD, '/whatsapp/billing'),
    // billingProfile: path(ROOTS_DASHBOARD, '/whatsapp/billing/billing-profile'),
    // billingpayment: path(ROOTS_DASHBOARD, '/whatsapp/billing/billing-payment'),
    // customerInvoice: path(ROOTS_DASHBOARD, '/whatsapp/billing/customer-invoice'),

    settings: path(ROOTS_DASHBOARD, '/whatsapp/settings'),
    templates: path(ROOTS_DASHBOARD, '/whatsapp/templates'),
    rates: path(ROOTS_DASHBOARD, '/whatsapp/rates'),
    partners: path(ROOTS_DASHBOARD, '/whatsapp/partners'),
    customers: path(ROOTS_DASHBOARD, '/whatsapp/customers'),
    analytics: path(ROOTS_DASHBOARD, '/whatsapp/analytics'),
    customerAnalytics: path(ROOTS_DASHBOARD, '/whatsapp/customers/customer-analytics'),
    transactions: path(ROOTS_DASHBOARD, '/whatsapp/transactions'),
    demo: {
      root: path(ROOTS_DASHBOARD, '/whatsapp/demo'),
      customize: path(ROOTS_DASHBOARD, '/whatsapp/demo/customize'),
      records: path(ROOTS_DASHBOARD, '/whatsapp/demo/records'),
    },
    customizeDemo: path(ROOTS_DASHBOARD, '/whatsapp/demo/customize'),

    fixDisplayName: path(ROOTS_DASHBOARD, '/whatsapp/fix-display-name'),
    onboardingConfig: path(ROOTS_DASHBOARD, '/whatsapp/onboarding-config'),
  },
  googleMyBusiness: {
    root: path(ROOTS_DASHBOARD, '/google-my-business'),
    partners: path(ROOTS_DASHBOARD, '/google-my-business/partners'),
    customers: path(ROOTS_DASHBOARD, '/google-my-business/customers'),
    transactions: path(ROOTS_DASHBOARD, '/google-my-business/transactions'),
    transactionInvoice: path(ROOTS_DASHBOARD, '/google-my-business/transaction-invoice'),
    setupApiKey: path(ROOTS_DASHBOARD, '/google-my-business/setup-api-key'),
  },
  discoveryCall: {
    root: path(ROOTS_DASHBOARD, '/discovery-call'),
    list: path(ROOTS_DASHBOARD, '/discovery-call/discovery-list'),
    discoverySetup: path(ROOTS_DASHBOARD, '/discovery-call/discovery-setup'),
    discoverySetupDetail: (id) => path(ROOTS_DASHBOARD, `/discovery-call/discovery-setup/${id}`),
  },
  notifications: path(ROOTS_DASHBOARD, '/notifications'),
  reports: path(ROOTS_DASHBOARD, '/reports'),
  developers: {
    root: path(ROOTS_DASHBOARD, '/developers'),
    apitoken: path(ROOTS_DASHBOARD, '/developers/api-token'),
  },

  supportChannel: path(ROOTS_DASHBOARD, '/support-channel'),

  // Whitelable Config
  whitelableConfig: path(ROOTS_DASHBOARD, '/whitelable-config'),
  billing: path(ROOTS_DASHBOARD, '/billing'),
  coupons: {
    root: path(ROOTS_DASHBOARD, '/coupons'),
    createCoupon: path(ROOTS_DASHBOARD, '/coupons/create-coupon'),
    couponView: (id) => path(ROOTS_DASHBOARD, `/coupons/coupon-view/${id}`),
    // editCoupon: (id) => path(PATH_DASHBOARD.coupons.root, `edit-coupon/${id}`),
  },

  // createBillingPayments: path(ROOTS_DASHBOARD, '/billing/create-payment-gateway'),
  // editBillingPayments: path(ROOTS_DASHBOARD, '/billing/edit-payment-gateway'),
  // leadsetup: path(ROOTS_DASHBOARD, '/leadsetup'),
  superUser: path(ROOTS_DASHBOARD, '/user-org-management'),
  organizations: {
    root: path(ROOTS_DASHBOARD, '/organizations'),
  },
};

/** Partners list URL for breadcrumbs; includes logged-in user id for context. */
export function partnersRootHrefWithLoginContext() {
  if (typeof window === 'undefined') {
    return PATH_DASHBOARD.partners.root;
  }
  const loginUserId = localStorage.getItem('loginUserId');
  if (loginUserId) {
    return `${PATH_DASHBOARD.partners.root}?loginUserId=${encodeURIComponent(loginUserId)}`;
  }
  return PATH_DASHBOARD.partners.root;
}
